import React, {useEffect, useState} from 'react';
import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
} from '../../../components/forms';
import {Column} from '../../../components/layout';
import * as Yup from 'yup';
import {uriGetEmailByTaxNumber} from '../../../api/endpoints';
import {get} from '../../../api/api';
import RegisterHeader from '../../../components/headers/register-header';
import {pageBackgrounds} from '../../../util/colors';
import {strings} from '../../../util/strings';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import * as fonts from '../../../util/fonts';
import './styles.scss';
import Header2 from '../../../components/headers/header2';
import {addToGlobalStyles, setGlobalStyles} from '../../../store/actions';
import AppErrorMessage from '../../../components/app-error-message';
import { ITenant } from '../../../App';
import {ApiResponse, createGUID} from '../../../util/utility';

interface ForgotEmailProps {
  addToGlobalStyles(value: any): void;
  setGlobalStyles(value: any): void;
  globalStyles: any;
  labels: typeof strings.pt.login;
  messageLabels: typeof strings.pt.messages;
  tenant: ITenant;
}
interface IdentityApiResponse {
  isValid: boolean;
  email: string;
}

function ForgotEmail({
  labels,
  messageLabels,
  addToGlobalStyles,
  setGlobalStyles,
  globalStyles,
  tenant,
}: ForgotEmailProps) {
  const [formikContext, setFormikContext] = useState();
  const [valid, setValid] = useState(false);
  const [enteredNif, setEnteredNif] = useState('');
  const [foundEmail, setFoundEmail] = useState(false);
  const [emailFound, setEmailFound] = useState('');
  const [emailNotFound, setEmailNotFound] = useState('');
  const [hoverErrorIcon, setHoverErrorIcon] = useState(false);
  const history = useHistory();

  const defineOnMouseFunctions = (e: React.MouseEvent) => {
    var elem: HTMLElement = e.target as HTMLElement;
    var icon: HTMLElement = elem.nextSibling as HTMLElement;
    if (icon) {
      icon.onmouseover = function () {
        setHoverErrorIcon(true);
      };
      icon.onmouseout = function () {
        setHoverErrorIcon(false);
      };
    }
  };

  const validationSchema = Yup.object().shape({
    nif: Yup.string()
      .required(messageLabels?.requiredField)
      .matches(
        new RegExp(tenant?.vatNumberValidator),
        messageLabels?.invalidFormat
      ),
  });

  useEffect(() => {
    addToGlobalStyles({
      background: pageBackgrounds.forgotPasswordPage,
    });
  }, []);

  useEffect(() => {
    const GetEmailByNif = async () => {
      await get(uriGetEmailByTaxNumber(enteredNif))
        .then((res: any) => {
          if (res?.data?.isValid === true) {
            let foundAddress = res?.data?.email;
            let hiddenString = obfuscateString(foundAddress);
            setEmailFound(hiddenString);
            setFoundEmail(true);
            setEmailNotFound('');
          } else {
            history.push('/deseja-registar');
          }
        })
        .catch((e: any) => {
          history.push('/deseja-registar');
        });
    };

    if (enteredNif !== '') {
      GetEmailByNif();
    }
  }, [enteredNif]);

  const obfuscateString = (value: string) => {
    let emailAddress = value?.split('@')[0];
    let emailDomain = value?.split('@')[1];

    let partiallyHiddemEmail = '';

    if (emailAddress.length > 4) {
      partiallyHiddemEmail =
        emailAddress[0] +
        emailAddress[1] +
        '*'.repeat(emailAddress.length - 3) +
        emailAddress.slice(-2);
    } else {
      partiallyHiddemEmail = '****';
    }
    return partiallyHiddemEmail + '@' + emailDomain;
  };

  return foundEmail ? (
    <>
      <RegisterHeader />
      <AppForm
        initialValues={{nif: ''}}
        validationSchema={validationSchema}
        onSubmit={(value) => setEnteredNif(value.nif)}
        onValidation={(valid) => setValid(valid)}>
        <Column>
          <Header2
            style={{...fonts.XL, fontWeight: 'bold', color: 'black'}}
            className="forgot-email-title">
            {labels?.login_forgotEmail_registerFound_title}
          </Header2>
          <p>{labels?.login_forgotEmail_registerFound_text}</p>
          <strong>{emailFound}</strong>
        </Column>
        <Column
          className="forgot-email-button-success"
          style={{
            width: '100%',
            paddingLeft: '20%',
            paddingRight: '20%',
            alignItems: 'center',
          }}>
          <AppFormSubmitButton
            disabled={false}
            title={labels?.login_forgotEmail_registerFound_button}
            onClick={() => history.push('/')}
          />
        </Column>
      </AppForm>
    </>
  ) : (
    <>
      <RegisterHeader />
      <Column>
        <Header2
          style={{...fonts.XL, fontWeight: 'bold', color: 'black'}}
          className="forgot-email-title">
          {labels?.login_forgotEmail_dontRememberEmail}
        </Header2>
        <p>{labels?.login_forgotEmail_fillNif}</p>
        <AppForm
          initialValues={{nif: ''}}
          validationSchema={validationSchema}
          onSubmit={(value) => setEnteredNif(value.nif)}
          onValidation={(valid) => setValid(valid)}>
          <Column
            className="forgot-email-button-column"
            width="100%"
            style={{
              paddingTop: '20px',
              margin: 'auto',
              alignItems: 'center',
              position: 'relative',
              maxWidth: '360px',
            }}>
            <AppFormField
              name="nif"
              placeholder="NIF"
              className="forgot-email-nif-input"
              onMouseOver={(e) => defineOnMouseFunctions(e)}
              handleFormikContext={(formik) => {
                if (
                  !!!formikContext ||
                  formik.errors !== (formikContext as any).errors
                ) {
                  setFormikContext(formik);
                }
              }}></AppFormField>
            {hoverErrorIcon && (
              <AppErrorMessage
                message={
                  (formikContext &&
                    (formikContext as any).errors &&
                    (formikContext as any).errors.nif) ||
                  messageLabels?.requiredField
                }
                className={'forgot-email-nif-error-message'}
              />
            )}
            <AppFormSubmitButton
              disabled={!valid}
              title={labels?.login_forgotEmail_button}
              /* className="forgot-email-button-continue" */
            />
          </Column>
        </AppForm>
      </Column>
    </>
  );
}

const mapStateToProps = ({stringsDefault, globalStyles, tenant}: any) => ({
  labels: stringsDefault.value.pt.login,
  messageLabels: stringsDefault.value.pt.messages,
  globalStyles: globalStyles.value,
  tenant: tenant.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ForgotEmail)
);
